import { resolveImportSource } from "./resolveImportSource.js";
export function getComponentReference(path, state, app, options) {
  var _options$componentBin;
  if (!path.isReferencedIdentifier()) {
    return null;
  }
  var componentName = path.node.name;
  var binding = path.scope.getBinding(componentName);
  if (!binding) {
    return null;
  }
  if ((_options$componentBin = options.componentBindings) !== null && _options$componentBin !== void 0 && _options$componentBin.has(binding.identifier)) {
    return {
      type: "local",
      name: componentName
    };
  }
  if (binding.kind === "module") {
    if (binding.path.isImportSpecifier() && binding.path.parentPath.isImportDeclaration()) {
      var imported = binding.path.get("imported");
      if (!imported.isIdentifier()) {
        state.errors.push({
          message: "Unsupported import specifier type: ".concat(imported.type),
          node: imported.node,
          severity: "error"
        });
        return null;
      }
      var source = binding.path.parentPath.get("source");
      return {
        type: "imported",
        name: imported.node.name,
        importSource: resolveImportSource(source.node.value, state.filePath, app.files)
      };
    }
    if (binding.path.isImportDefaultSpecifier() && binding.path.parentPath.isImportDeclaration()) {
      var _source = binding.path.parentPath.get("source");
      return {
        type: "imported",
        importSource: resolveImportSource(_source.node.value, state.filePath, app.files)
      };
    }
  }
  state.errors.push({
    message: "Unsupported component binding for \"".concat(componentName, "\""),
    node: binding.identifier,
    severity: "error"
  });
  return null;
}
//# sourceMappingURL=getComponentReference.js.map